<template>
  <empty-cart
    v-if="isCartEmpty"
    :title="'Wishlist'"
    :item-name="'wishlist'"
    :where-to-go-button="'bag'"
    :to="{ name: 'Cart' }"
  ></empty-cart>

  <loading-page v-else-if="isLoading"></loading-page>

  <div v-else class="cart">
    <h1 class="title">Wishlist</h1>
    <p class="items-para">Items:</p>
    <transition-group name="fade" tag="ul" class="products">
      <li
        v-for="product in formattedCart"
        :key="product._id"
        class="wishlist-info"
      >
        <button @click="removeFromWishlist(product)" class="remove-container">
          <img src="/images/remove.svg" alt="remove button" />
        </button>
        <div class="img-container">
          <img
            v-if="product.productId && product.productId.image"
            :src="product.productId.image"
            :alt="product.productId.name"
            class="wishlist-product-img"
          />
        </div>
        <p v-if="product.productId" class="wishlist-product-title">
          <strong>{{ product.productId.name }}</strong>
        </p>
        <p v-if="product.productId" class="wishlist-product-price">
          Price: {{ product.productId.price }}$
        </p>
        <p
          v-if="product.productId"
          class="wishlist-product-price margin-bottom"
        >
          Color: {{ getColorName(product.productId.color) }}
        </p>
        <p v-if="!selectedSize" class="error">Select the size!</p>
        <div class="size-container">
          <div class="cont">
            <input type="radio" name="size" value="S" v-model="selectedSize" />
            <label class="size" for="size-s"> S </label>
          </div>

          <div class="cont">
            <input type="radio" name="size" value="M" v-model="selectedSize" />
            <label class="size" for="size-m"> M </label>
          </div>

          <div class="cont">
            <input type="radio" name="size" value="L" v-model="selectedSize" />
            <label class="size" for="size-l"> L </label>
          </div>

          <div class="cont">
            <input type="radio" name="size" value="XL" v-model="selectedSize" />
            <label class="size" for="size-xl"> XL </label>
          </div>

          <div class="cont">
            <input
              type="radio"
              name="size"
              value="XXL"
              v-model="selectedSize"
            />
            <label class="size" for="size-xxl"> XXL </label>
          </div>
        </div>
        <!-- сделать кнопку базовой -->
        <button class="add-to-cart" @click="addToBag(product)">
          Add to bag
        </button>
      </li>
    </transition-group>
  </div>
</template>

<script>
import EmptyCart from "./EmptyCart.vue";
import { mapGetters } from "vuex";
import namer from "color-namer";

export default {
  components: { EmptyCart },

  data() {
    return {
      selectedSize: null,
      isLoading: true,
    };
  },

  computed: {
    ...mapGetters("wishlist", ["getWishlist"]),

    userId() {
      const userData = this.$store.getters.userData;
      return userData && userData.id ? userData.id : "guest";
    },

    formattedCart() {
      if (this.userId === "guest") {
        return this.getWishlist.map((product) => ({
          _id: product._id,
          productId: product.productId,
        }));
      } else {
        return this.getWishlist.products || [];
      }
    },

    isCartEmpty() {
      if (this.userId === "guest") {
        return this.getWishlist.length === 0;
      } else {
        return (
          !this.getWishlist.products || this.getWishlist.products.length === 0
        );
      }
    },
  },

  methods: {
    addToBag(product) {
      this.$store.dispatch("checkLoggedIn");

      // Получаем информацию о продукте и выбранном размере
      const productInfo = {
        productId: product.productId?._id || product.productId?.id,
        productTitle: product.productId?.name,
        productImage: product.productId?.image,
        productPrice: product.productId?.price,
        productColor: product.productId?.color,
        productSize: this.selectedSize,
      };

      if (!productInfo.productSize) {
        this.showError = true;
        return;
      } else {
        this.showError = false;
      }

      const userData = this.$store.getters.userData;
      let userId = userData && userData.id ? userData.id : "guest";

      console.log("User ID:", userId);
      console.log("Product Info:", productInfo);
      console.log("size:", productInfo.productSize);

      // Диспатчим действие, передавая данные
      this.$store.dispatch("cart/addToCart", {
        userId,
        productId: productInfo.productId,
        size: productInfo.productSize,
      });
      this.removeFromWishlist(product);
    },

    getColorName(hex) {
      if (!hex) return "unknown";
      return namer(hex).html[0].name;
    },

    removeFromWishlist(product) {
      const userData = this.$store.getters.userData;
      const userId = userData && userData.id ? userData.id : "guest";

      const productId = product.productId?._id || product.productId?.id;

      console.log("userId:", userId, "productId:", productId);

      this.$store.dispatch("wishlist/removeFromWishlist", {
        userId,
        productId,
      });
    },
  },

  async mounted() {
    this.$store.dispatch("checkLoggedIn");
    const userData = this.$store.getters.userData;
    const userId = userData && userData.id ? userData.id : "guest";
    await this.$store.dispatch("wishlist/fetchWishlist", userId).then(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.title {
  color: #000;
  font-family: "Glusp";
  font-size: clamp(2rem, 5vw, 3.6rem);
  font-weight: 700;
  text-align: center;
  margin-bottom: 45px;
}

.products {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  list-style-type: none;
}

.img-container {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.cart {
  padding: 40px;
}

.remove-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 4px;
  background: #ececec;
  width: 48px;
  cursor: pointer;
}

.remove-container > img {
  height: 28px;
}

.wishlist-info {
  border-radius: 5px;
  background: #fff;
  min-width: 28rem;
  max-width: 35rem;
  padding: 20px;

  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wishlist-product-img {
  max-width: 29rem;
  height: 29rem;
  border-radius: 5px;
}

.wishlist-product-title {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 500;
}

.wishlist-product-price {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.margin-bottom {
  margin-bottom: 15px;
}

.items-para {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.4rem;
  font-weight: 300;
  margin-bottom: 25px;
  /* padding-left: 40px; */
}

.add-to-cart {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 500;
  border-radius: 4.073px;
  background: #000;
  padding: 8px 18px;
  text-align: center;
}

.size-container {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 25px;
}

.size {
  padding: 7px 15px;
  border: 0.5px solid #000;
  display: flex;
  justify-content: center;
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.1rem;
  font-weight: 300;
  max-width: 4.5rem;
  cursor: pointer;
}

.cont {
  position: relative;
  cursor: pointer;
}

.size:hover {
  background: #000;
  color: #fff;
}

input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  /* opacity: 0; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 100%;
  height: 100%;
}

input[type="radio"]:checked + .size {
  background-color: #000;
  color: #fff;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  .products {
    justify-content: center;
  }
  .wishlist-product-img {
    height: 20rem !important;
  }
  .cart {
    padding: 40px 10px;
  }
  .items-para {
    text-align: center;
    padding-left: 0;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .products {
    justify-content: center;
  }
  .items-para {
    text-align: center;
    padding-left: 0;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
}

@media screen and (min-width: 1200px) and (max-width: 1900px) {
}
</style>